import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Login.css";

/**
 * Firebase password-reset emails sometimes open /__/auth/action?mode=resetPassword&oobCode=…
 * on the app host. Forward to our in-app reset screen so users get confirm password + requirements.
 */
function FirebaseAuthActionRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const qs = searchParams.toString();

  useEffect(() => {
    const p = new URLSearchParams(qs);
    const mode = p.get("mode") || "";
    const oobCode = (p.get("oobCode") || "").trim();
    if (mode === "resetPassword" && oobCode) {
      navigate(`/ResetPassword?${qs}`, { replace: true });
      return;
    }
    navigate("/ForgotPassword", { replace: true });
  }, [navigate, qs]);

  return (
    <div className="login-page">
      <div className="login-form-column" style={{ paddingTop: 48, maxWidth: 420, margin: "0 auto" }}>
        <p className="auth-muted">Redirecting…</p>
      </div>
    </div>
  );
}

export default FirebaseAuthActionRedirect;
